










import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import NavBar from '@/components/nav/nav.vue';
import { getUserInfo } from '@/apis/common';
import { getImToken } from '@/apis/message/message';
import { Dialog, Toast } from 'vant';
import WsAppModule from '@/utils/websocket';
import checkInApi from '@/apis/checkIn/checkIn';
import checkInBlackList from '@/Configurations/checkInBlackList';
import urlConfig from '@/Configurations/urlConfig';
import { getTokenByCode } from '@/apis/login/login';
import { whiteList } from '@/Configurations/routerWhiteList';
import { getWxConfig } from '@/store/checkIn';
import {usePathTokenTologin,isMobileDevice, getUrlQueryUseHash} from '@/utils/utils';
import {geMobiletCurrentURL} from '@/utils/common'
import '@/utils/directive/courseAuthDisabledDirective'
import '@/utils/directive/PrivateDeployModuleHide'
import '@vant/touch-emulator';

enum stateType {
  normalLogin = 'normalLogin',
  loginByWechat = 'loginByWechat'
}

/**
 * 企业微信客户端
 */
function isWorkWechat() {
    //获取user-agaent标识头
    var ua = window.navigator.userAgent.toLowerCase();
    //判断ua和微信浏览器的标识头是否匹配
    // @ts-ignore
    if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
          return true;
    } else {
          return false;
    }
}

/**
 * 纯微信客户端，不含企业微信
 */
function isWxClient(): boolean {
  if(isWorkWechat()){
    return false;
  }
  var ua = window.navigator.userAgent.toLowerCase();
  //判断ua和微信浏览器的标识头是否匹配
  // @ts-ignore
  if (ua.match(/micromessenger/i) == 'micromessenger') {
        return true;
  } else {
        return false;
  }
}


function makeWechatRedirectUri(appid: string, redirectUri: string): (state: stateType) => string {
  return function(state: stateType) {
    const uri = encodeURIComponent(redirectUri + '/preLogin');
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=${state}`;
  };
}

const jumpWhiteList = ['/conference'];

@Component({ components: { NavBar} })
export default class App extends Vue {
  private isShowPage = true;
  private redirectUriFunction!: (state: stateType) => string;
  private appid: string = '';
  isPc = false;


  @Watch('$route', {
    immediate: true
  })
  async onchangeRoute() {
    if(this.wsMsgModule.loginParam === undefined && localStorage.token) {
      await getImToken().then(res => {
        res.pageCurrent = 1;
        res.pageSize = 50;
        this.wsMsgModule.loginParam = res;
        this.wsMsgModule.login(res);
      }).catch(e => {
        console.log(e);
      });
    }
  }

  created() {
    usePathTokenTologin();
    const urlCache = window.location.href;
    jumpWhiteList.forEach((url: string) => {
      if (new RegExp(url).test(urlCache)) {
        window.localStorage.setItem('urlCache', location.pathname + location.search);
      }
    });
    window.addEventListener('onLoginSucceed', this.handleonLoginSucceed.bind(this));
    this.isPc = !isMobileDevice();
    if(this.isPc){
      //@ts-ignore
      if(window?.styleMedia != null){
        //@ts-ignore
        window?.styleMedia.type.fontsize('12px');
      }
    }
    // if (/html/.test(this.$route.path)) {
    //   this.$router.push('/')
    // }
    let { code, state, appid } = this.$route.query as any;
    // state = state)
    if (Array.isArray(appid)) {
      alert(`appid error, now is ${JSON.stringify(appid)}`); //
      this.$router.push('/login');
      return;
    }
    if (!appid || appid === 'undefined' || appid === undefined) {
      if (window.localStorage.getItem('appid_cache')) {
        appid = window.localStorage.getItem('appid_cache');
      } else {
        appid = urlConfig.appid;
      }
    } else {
      window.localStorage.setItem('appid_cache', appid);
    }
    this.appid = appid;
    this.redirectUriFunction = makeWechatRedirectUri(appid, urlConfig.redirectUri);
    // 登录鉴权
    this.loginHandler(code, state);
    let newURL = geMobiletCurrentURL();
    getWxConfig({url:newURL}).then((config:any) => {
      // @ts-ignore
      // eslint-disable-next-line no-undef
      wx.config({
        debug: false,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: ['startRecord', 'stopRecord']
      });
    });

    if(getUrlQueryUseHash('from')) {
      this.fromJiGou()
    }
  }

  // 来自机构
  fromJiGou() {
    sessionStorage.from = getUrlQueryUseHash('from');
  }

  loginHandler(code: string | any, state: stateType) {
    const handleError = (code: string) => {
      this.$router.push({
        path: '/login',
        query: { code }
      });
    };
    const token = window.localStorage.getItem('token');
    //当前的URL链接
    if(!token && ['/courseHome', '/joinCourse', '/ShareClass'].includes(location.pathname)){
      sessionStorage.from = location.href;
    }
    // 处于白名单中，直接访问
    this.$router.onReady(() => {
      if(token && !this.$store.getters.getUserInfo.id) {
        this.$store.dispatch('setUserInfo');
      }
      if (!whiteList.includes(this.$route.path)) {
        if (token) {
          window.dispatchEvent(new CustomEvent('onLoginSucceed'));
          this.isShowPage = false;
          this.$store
            .dispatch('setUserInfo')
            .then(() => {
              // 用router-view的刷新来确保 所有的router-view都可以从store的getter里面拿到UserInfo。
              this.isShowPage = true;
              if (this.$route.path === '/login' || this.$route.path === '/preLogin') {
                this.$router.push('/');
              }
            })
            .catch(e => {
              window.localStorage.removeItem('token');
              this.$router.push({
                path: '/login',
                query: { code }
              });
            });
        } else if (this.$route.path !== '/login') {
          if (isWxClient()) {
            // 只要是redirect过来的url都会有state，即使没有code（这代表用户没有全授权微信拿自己的信息），也会有state，因为这个是我传的
            if (!state) {
              window.location.href = this.redirectUriFunction(stateType.normalLogin);
            } else if (code) {
              getTokenByCode(code, this.appid)
                .then(res => {
                  window.localStorage.setItem('code_key', res.code_key);
                  if(res.openid) {
                    localStorage.openid = res.openid;
                  }
                  switch (state) {
                    case stateType.normalLogin: {
                      if (res.otherType === 2) {
                        handleError(code);
                      }
                      if (res.otherType === 1) {
                        window.localStorage.setItem('token', res.token);
                        window.dispatchEvent(new CustomEvent('onLoginSucceed'));
                        this.isShowPage = false;
                        this.$store
                          .dispatch('setUserInfo')
                          .then(() => {
                            // 用router-view的刷新来确保 所有的router-view都可以从store的getter里面拿到UserInfo。
                            this.isShowPage = true;
                            if (this.$route.path === '/login' || this.$route.path === '/preLogin') {
                              this.$router.push('/');
                            }
                          })
                          .catch(e => {
                            window.localStorage.removeItem('token');
                            handleError(code);
                          });
                      }
                      break;
                    }
                    case stateType.loginByWechat: {
                      if (res.otherType === 2) {
                        // 去绑定
                        this.$router.push('/bindWechat');
                      }
                      if (res.otherType === 1) {
                        window.localStorage.setItem('token', res.token);
                        window.dispatchEvent(new CustomEvent('onLoginSucceed'));
                        this.isShowPage = false;
                        this.$store
                          .dispatch('setUserInfo')
                          .then(() => {
                            // 用router-view的刷新来确保 所有的router-view都可以从store的getter里面拿到UserInfo。
                            this.isShowPage = true;
                            if (this.$route.path === '/login') {
                              this.$router.push('/');
                            }
                          })
                          .catch(e => {
                            window.localStorage.removeItem('token');
                            handleError(code);
                          });
                      }
                      break;
                    }
                    default:
                  }
                })
                .catch(e => {
                  let msg;
                  try {
                    msg = JSON.stringify(e);
                  } catch (err) {
                    msg = 'getTokenByCode error';
                  }
                  // alert(`api请求的url地址是基础地址是 ${urlConfig.httpRequestUrl}/UserApi/getInfoStatusByCode, 错误是${msg}`);
                  handleError(code);
                });
            } else {
              handleError('');
            }
          } else {
            this.$router.push({ path: '/login' });
          }
        }
      }
    });
  }

  mounted() {
    Toast.clear();
  }

  // @Watch('$route', { immediate: true })
  // private changeRouter(route: any) {
  //   const ws = sessionStorage.getItem('checkWsInfo') as string;
  //   if (!ws) return;
  //   const value = this.handleBlackList(route);
  //   if (!value) this.$store.dispatch('getNotFinishAttenceStudent');
  // }
  
  handleBlackList(to: any): boolean {
    // 黑名单处理
    const flag = checkInBlackList.find((x: any) => to.path.includes(x)) as any;
    return !!flag;
  }

  handleonLoginSucceed() {
    const ws = WsAppModule
    this.wsMsgModule.init();
  }

}
